/**
 * Início in Modo simples (docs/refactor/51, N5): the Super skills as big cards at the top — what the AI can
 * do, one click each — so somebody who does not program starts from a thing to make, not from a screen of
 * sessions. A card opens its menu in the prompt box, as the Super skills button and Ctrl+K do.
 */

import { openSuperSkills } from '../lib/dockPlacement'
import { useSuperSkills } from '../lib/teamSuperSkills'
import { useI18n } from '../lib/i18n'
import { local } from '../lib/superSkills'
import { superSkillIcon } from './SuperSkills'

export function SimpleHome() {
  const { t, locale } = useI18n()
  // The catalog's and the team's own (51, §6.2).
  const { skills } = useSuperSkills()
  if (skills.length === 0) return null
  return (
    <section className="panel simple-home" aria-labelledby="simple-home-title">
      <div className="stack stack--tight">
        <h2 id="simple-home-title" className="simple-home__title">{t('simple.home.title')}</h2>
        <p className="small muted" style={{ margin: 0 }}>{t('simple.home.hint')}</p>
      </div>
      <div className="super-skills__grid">
        {skills.map((skill) => (
          <button key={skill.key} type="button" className="super-skills__card" onClick={() => openSuperSkills(skill.key)}>
            <span className="super-skills__icon" aria-hidden>{superSkillIcon(skill.icon)}</span>
            <span className="super-skills__name">{local(skill.title, locale)}</span>
            {skill.team && <span className="super-skills__team tiny" title={skill.team}>{t('superSkills.team')}</span>}
            <span className="tiny muted">{local(skill.description, locale)}</span>
          </button>
        ))}
      </div>
    </section>
  )
}
